import type { Decision, Lifecycle, Confidence } from '@mas-flow/types';

export type GroupBy = 'decision' | 'lifecycle' | 'priorityBand' | 'category';

export interface FilterState {
  q: string;                                  // text search
  category: readonly string[];                // category IDs, e.g. 'cat-it'
  decision: readonly (Decision | null)[];     // null token = items with decision=null
  lifecycle: readonly Lifecycle[];
  confidence: readonly Confidence[];
  anchorsOnly: boolean;
  showArchived: boolean;
  group: GroupBy | null;                       // null = use role-default at the call site
  sort: ReadonlyArray<{ field: string; dir: 'asc' | 'desc' }>;
  cols: readonly string[];                     // visible column ids; empty = default set
}

export const EMPTY_FILTERS: FilterState = {
  q: '',
  category: [],
  decision: [],
  lifecycle: [],
  confidence: [],
  anchorsOnly: false,
  showArchived: false,
  group: null,
  sort: [],
  cols: [],
};
